import { render, staticRenderFns } from "./SamTag.vue?vue&type=template&id=0360eb83&scoped=true&"
import script from "./SamTag.vue?vue&type=script&lang=js&"
export * from "./SamTag.vue?vue&type=script&lang=js&"
import style0 from "./SamTag.vue?vue&type=style&index=0&id=0360eb83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0360eb83",
  null
  
)

export default component.exports